export const serviceTypes = {
  RESTRICTEDDATA: 'RESTRICTEDDATA'
};
